import type { I18nT } from "@lib/dashboardI18n";
import { exhaustiveCheck } from "@lib/exhaustiveCheck";

import type { OptimizationEventType } from "@canvas/Steps/ContentOptimizationStep/ContentOptimizationStep.types";

export interface OptimizationEventLabels {
  eventLabel: string;
  eventRateLabel: string;
}

export function getOptimizationEventLabels(
  eventType: OptimizationEventType | undefined,
  t: I18nT<"content-optimization">
): OptimizationEventLabels | null {
  if (!eventType) {
    return null;
  }

  switch (eventType) {
    case "opens":
      return {
        eventLabel: t("optimization-event-opens", "Opens"),
        eventRateLabel: t("optimization-event-opens-rate", "Open rate"),
      };
    case "clicks":
      return {
        eventLabel: t("optimization-event-clicks", "Clicks"),
        eventRateLabel: t("optimization-event-clicks-rate", "Click rate"),
      };
    case "reads":
      return {
        eventLabel: t("optimization-event-reads", "Reads"),
        eventRateLabel: t("optimization-event-reads-rate", "Read rate"),
      };
    case "link_clicks":
      return {
        eventLabel: t("optimization-event-link-clicks", "Link clicks"),
        eventRateLabel: t("optimization-event-link-click-rate", "Link click rate"),
      };
    default:
      exhaustiveCheck(eventType);
      return null;
  }
}
